// App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Editor from "./pages/Editor";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import "./App.css"
import AudienceView from "./pages/AudienceView";
import PresenterView from "./pages/PresenterView";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Landing />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/editor/:deckId"
          element={
            <ProtectedRoute>
              <Editor />
            </ProtectedRoute>
          }
        />
        {/* URL: yourdomain.com/watch/apple-deck-id */}
        <Route path="/watch/:deckId" element={<AudienceView />} />
        
        {/* URL: yourdomain.com/present/apple-deck-id */}
        <Route
          path="/present/:deckId"
          element={
            <ProtectedRoute>
              <PresenterView />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <PublicRoute>
              <Landing />
            </PublicRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
